

























































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";

import Decisions from "@/store/modules/Decisions";
import Viewpoints from "@/store/modules/Viewpoints"
import Choices from "@/store/modules/Choices";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
//@ts-ignore
import { NotificationEventBus } from "@/EventBus";
import BasicInputForm from "@/components/forms/BasicInputForm.vue";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import ScoringKeys from "@/store/modules/ScoringKeys";
import { Viewpoint } from "@/api/model/Viewpoint";
import ViewpointVisibilityDialog from "@/components/workspace-options/ViewpointVisibilityDialog.vue";
import UserAvatar from "@/components/common/UserAvatar.vue";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { ViewpointChoiceFactor } from "@/api/model/ViewpointChoiceFactor";
import _ from "lodash";
import { ViewpointFactorResource } from "@/api/model/ViewpointFactorResource";
import ListInputDialog from "@/components/forms/ListInputDialog.vue";

const usersModule = getModule(Users);
const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const workspaceOptions = getModule(WorkspaceOptions)
const scoringKeysModule = getModule(ScoringKeys);

@Component({
    components: {
        ViewpointVisibilityDialog,
        ConfirmationDialog,
        BasicInputForm,
        ScoringKeyEditorDialog,
        UserAvatar,
        ListInputDialog
    }
})

export default class ViewpointNavigation extends Vue {

    private search: string | null = null;
    private open: any[] = [];

    private formViewpoint = {};
    private createViewpointDialog = false;
    private editViewpointDialog = false;
    private generateViewpointDialog = false;
    private cloneViewpointDialog = false;
    private originalViewpoint: any = {};
    private loading = false;
    private adding = false;
    private doingMenuAction = false;
    private generationOptions = [
        'None',
        'Include Scores',
        'Include Slope',
        'Just Scores',
        'Scores to Ranks',
        'Weights to 3 bins quantile',
        'Decision Tree Weights',
    ];
    private generationFunctions = [{name: `Estimate Score From Ranking`, id: 'score_estimation_from_ranking'}, {name: `Generate Consensus ${this.singularViewpointLabel}`, id: 'generate_consensus_viewpoint'}]    // kat(may05)
    private refreshing = false;
    private deleteMode = false;
    private deleteList = [];

    @Prop({default: false, type: Boolean})
    menuWeight!: boolean;

    @Prop({default: false, type: Boolean})
    menuNew!: boolean;

    @Prop({default: false, type: Boolean})
    menuVisible!: boolean;

    @Prop({default: false, type: Boolean})
    menuEdit!: boolean;

    @Prop({default: false, type: Boolean})
    menuKey!: boolean;

    @Prop({default: 'Select a Viewpoint', type: String})
    header!: string;

    private visibilityEditViewpointId = '';

    // Get the values to display which one is selected in the tree
    get activeItems(): any[] {
        if (this.activeViewpointId) {
            return [{viewpointId: this.activeViewpointId}];
        }
        return [];
    }

    // When this value gets changed we need to update the module so that it reflects the selected value on all views
    set activeItems(treeItems: any[]) {
    }

    get activeViewpointId() {
        return viewpointsModule.activeViewpointId;
    }

    private async refreshViewpoints() {
        this.refreshing = true;
        let viewpoints = await decisionsModule.getDecisionViewpoints(this.selectedDecisionId);
        await decisionsModule.getDecisionLists();
        this.refreshing = false;
    }

    private async selectActiveViewpoint(viewpointId: string | null = null) {
        if (viewpointId) {
            await this.selectViewpoint(viewpointId);
        }
        viewpointsModule.selectActiveViewpoint(viewpointId);
    }

    get selectedDecisionId() {
        return decisionsModule.selectedDecisionId;
    }
    get selectedViewpointIds() {
        return viewpointsModule.selectedViewpointIds;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get selectedDecision() {
        this.deleteMode = false;
        this.deleteList = [];
        return decisionsModule.selectedDecision;
    }

    get viewpointScoringKeyDefinitions() {
        console.log("viewpointnavigation")
        return scoringKeysModule.viewpointScoringKeyDefinitions;
    }

    get viewpointList(): Viewpoint[] {
        return viewpointsModule.decisionViewpoints || [];
    }

    get currentUserId() {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
    }

    get userOwnedDecisionViewpointList() {
        return this.viewpointList.filter(v => v.ownerUserId === this.currentUserId)
    }

    get userNotOwnedDecisionViewpointList() {
        return this.viewpointList.filter(v => v.ownerUserId !== this.currentUserId)
    }

    get isDecisionOwner() {
        if (this.selectedDecision) {
            return this.currentUserId === this.selectedDecision.ownerUserId
        }
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get viewpointTree(): any[] {
        let vpList = JSON.parse(JSON.stringify(this.viewpointList))
        return [{
            viewpointId: 'ROOT',
            name: `${this.pluralViewpointLabel}`,
            children: vpList.filter(viewpoint => viewpoint.name).sort((a: any, b: any) => {
                if (a.name === b.name) return 1;
                return a.name.localeCompare(b.name);
            })
        }];
    }

    get activeViewpointList() {
        return workspaceOptions.activeViewpointLists
    }

    private async selectViewpoint(viewpointId: string) {
        if (viewpointId && viewpointId !== 'ROOT') {
            await viewpointsModule.selectViewpoint(viewpointId);
            await workspaceOptions.resetViewpointColumnsWidth();
        }
    }

    private async deselectViewpoint(viewpointId: string) {
        if (viewpointId && viewpointId !== 'ROOT') {
            await viewpointsModule.deselectViewpoint(viewpointId)
                .then(() => {
                    if (viewpointId === this.activeViewpointId) {
                        viewpointsModule.selectActiveViewpoint(null);
                    }
                });
        }
    }

    private async createViewpoint(viewpoint: any) {
        if (!this.selectedDecision) return;
        this.adding = true
        let sampleViewpoint = _.cloneDeep(viewpoint)
        NotificationEventBus.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            let res = await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description
            })
            if(sampleViewpoint.addToList && this.activeViewpointList?.length > 0) {
                decisionsModule.addViewpointToActiveLists(res.viewpointId)
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        console.log(viewpoint);
        this.adding = false;
    }

    private async deleteViewpoint(viewpointId: string) {
        this.doingMenuAction = true;
        NotificationEventBus.emitProcessingMessage();
        try {
            await decisionsModule.deleteViewpoint(viewpointId);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        this.doingMenuAction = false;
    }

    private editViewpointClick(viewpoint: Viewpoint) {
        this.formViewpoint = viewpoint;
        this.editViewpointDialog = true;
    }

    private editVisibilityClick(viewpoint: Viewpoint) {
        this.visibilityEditViewpointId = viewpoint.viewpointId
        // getModule(Dialogs).editViewpointVisibility(viewpoint.viewpointId);
    }

    private async editViewpoint(payload: Viewpoint) {
        this.editViewpointDialog = false;
        NotificationEventBus.emitProcessingMessage();
        try {
            await decisionsModule.updateViewpoint(payload);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    get userId(): string {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return '[user]';
    }

    get userList() {
        return decisionsModule.selectedDecisionUsers;
    }

    private isUserAllowedToDelete(viewpoint: any) {
        let userRole = this.userList[this.userId]?.permissionAccess
        let viewpointUserId = viewpoint.ownerUserId
        let viewpointUserRole = this.userList[viewpointUserId]?.permissionAccess
        switch(userRole) {
            case "OWNER": 
                return true;
                break;
            case "ADMIN": 
                //Don't allow deletion of viewpoints when viewpoint is owned by owner or other admin
                if(viewpointUserId != this.userId && (viewpointUserRole === "OWNER" || viewpointUserRole === "ADMIN")) {
                    return false;
                } else {
                    return true;
                }
                break;
            case "EDIT":
                if(viewpointUserId === this.userId) {
                    return true;
                } else {
                    return false;
                }
                break;
            default: return false;
        }
    }

    private async generateViewpoint(payload: any) {
        NotificationEventBus.emitProcessingMessage();
        this.generateViewpointDialog = false;
        try{
            await viewpointsModule.generateViewpoint(payload)
           NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    // Create Viewpoint(s) from a List
    private async createViewpointsFromList(payload: any) {
        let list = payload.names;
        let addToList = payload.addToList
        let results = []
        this.refreshing = true;
        if (list.length) {
            let viewpoints = list.filter(l => l)
                .map(name => {
                    return {
                        name: name,
                        addToList: addToList
                    }
                })
            viewpoints.forEach(( v: any ) => {
                this.createViewpoint(v);
            })
        }
        this.refreshing = false;
    }
    private setOriginalViewpoint(viewpoint: Viewpoint) {
        this.originalViewpoint = _.cloneDeep(viewpoint);
        console.log(this.originalViewpoint)
        this.cloneViewpointDialog = true;

    }

    private async cloneViewpoint(payload: any) {
        this.cloneViewpointDialog = false
        if (!this.selectedDecision) return;
        NotificationEventBus.emitProcessingMessage();
        let original: Viewpoint = _.cloneDeep(this.originalViewpoint);
        let newParams = _.cloneDeep(payload)
        try{
            await viewpointsModule.cloneViewpoint({original: original, newViewpoint: newParams, includeWeights: true, includeKeys: true, includeScores: true})
            NotificationEventBus.emitSuccessMessage();
        } catch(err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private async deleteMultiple() {
        if(!this.deleteMode) {
            this.deleteMode = !this.deleteMode
            return
        }

        else {
            if(this.deleteList.length > 0) {
                await decisionsModule.deleteMultipleViewpoints(this.deleteList)
            }
            this.deleteList = [];
            this.deleteMode = false;
            return
        }
    }

}

